import CheckOutIndexVue from "@/views/check-out/CheckOutIndex.vue";

const checkout = [
  {
    path: "/checkout",
    name: "checkout",
    component: CheckOutIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default checkout;
